import { render, staticRenderFns } from "./AppDrag.vue?vue&type=template&id=f731d558&scoped=true"
import script from "./AppDrag.vue?vue&type=script&lang=js"
export * from "./AppDrag.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f731d558",
  null
  
)

export default component.exports